module.exports = __webpack_public_path__ + "static/img/14000551.43fd1b78.png";